import axios from '@/assets/js/axios'
import { emAppUrl } from '@/config'
const LocalKey = 'EMONEY_MOBILE_USER_STATISTICS_USER_GUID'

/**
 * 打点
 */
export function addStatistics(params) {
  const userGuid = localStorage.getItem(LocalKey) || ''

  axios
    .get(`${emAppUrl}/Statistics/ShareAnalysis/Add`, {
      params: {
        userGuid,
        ...params
      }
    })
    .then(({ result, detail }) => {
      if (result.code === 0) {
        localStorage.setItem(LocalKey, detail)
      }
    })
}



// WEBPACK FOOTER //
// ./src/api/statistics.js